import { render, staticRenderFns } from "./ViewDet.vue?vue&type=template&id=0254487d&scoped=true&"
import script from "./ViewDet.vue?vue&type=script&lang=js&"
export * from "./ViewDet.vue?vue&type=script&lang=js&"
import style0 from "./ViewDet.vue?vue&type=style&index=0&id=0254487d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0254487d",
  null
  
)

export default component.exports